export const allTypesToSelectHome = [
    { value: "invoicing", label: "Faturamento" },
    { value: "obligation", label: "Obrigação" },
    { value: "investment", label: "Investimento em P&D" }
];